/**
 * Employee Web — `/me/reviews/$reviewId`: the review answering screen.
 *
 * The flow owns its own page header (the task, the cycle, the deadline and the
 * autosave pill); the route adds none, or the page would carry two stacked
 * headers.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ReviewerFlow } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/reviews/$reviewId")({
  staticData: { breadcrumb: { labelKey: "appraisal:reviews.title" } },
  component: ReviewerFlowRoute,
});

function ReviewerFlowRoute(): JSX.Element {
  const { reviewId } = Route.useParams();
  return <ReviewerFlow reviewId={reviewId} />;
}
